import { getRibbonTextContainerSelector } from "@1js/acui-common";

export const compareTootlipAndElementLabel = (
  tooltipLabel: string,
  id?: string
): boolean => {
  if (!id) {
    return true;
  }
  const textContainer = document
    .getElementById(id)
    ?.querySelector(
      getRibbonTextContainerSelector(true /**useOptimizedSelectors*/)
    );
  if (
    textContainer &&
    textContainer.textContent === tooltipLabel &&
    window.getComputedStyle(textContainer).display !== "none"
  ) {
    return false;
  }
  return true;
};
